"use client";
import React from "react";

export default function Custom500() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 animate-fadeIn">
      <div className="bg-white shadow-lg rounded-2xl p-10 max-w-md text-center animate-slideUp">
        <div className="text-red-500 text-6xl font-extrabold mb-4 animate-bounceSlow">
          500
        </div>
        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Oops! Something went wrong.
        </h1>
        <p className="text-gray-600 mb-6">
          We're experiencing an internal server error. Please try again later.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-6 rounded-full transition duration-300 hover:animate-pulse"
        >
          Reload Page
        </button>
      </div>

      {/* Tailwind CSS custom animations via style tag (if not using tailwind.config.js) */}
      <style jsx>{`
        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          0% {
            transform: translateY(30px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes bounceSlow {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.8s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.6s ease-out;
        }

        .animate-bounceSlow {
          animation: bounceSlow 2s infinite;
        }
      `}</style>
    </div>
  );
}
